import React, { useMemo } from "react";
import { motion } from "framer-motion";

export const Particles = ({ count = 14 }) => {
  const items = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      size: 6 + Math.random() * 18,
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 4,
      duration: 6 + Math.random() * 6,
      drift: 20 + Math.random() * 60,
      opacity: 0.25 + Math.random() * 0.35,
    }));
  }, [count]);

  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
      data-testid="hero-particles"
    >
      {items.map((p) => (
        <motion.span
          key={p.id}
          className="absolute rounded-full"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: p.size,
            height: p.size,
            background:
              "radial-gradient(circle at 30% 30%, rgba(245,130,32,0.9), rgba(245,130,32,0.15) 70%, transparent 75%)",
            opacity: p.opacity,
            filter: "blur(0.3px)",
          }}
          animate={{
            y: [0, -p.drift, 0],
            x: [0, p.drift / 2, 0],
            scale: [1, 1.15, 1],
          }}
          transition={{
            duration: p.duration,
            repeat: Infinity,
            ease: "easeInOut",
            delay: p.delay,
          }}
        />
      ))}
    </div>
  );
};
